import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { SgoSituacoesDemandaService } from '../services/sgo-situacoes-demanda.service';


@Injectable({
  providedIn: 'root'
})
export class SgoSituacoesDemandaResolver implements Resolve<boolean> {

  constructor(private service: SgoSituacoesDemandaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}